/* 🤖 this file was generated by svg-to-ts */
export const iconSoneium: {
  name: 'soneium';
  data: string;
} = {
  name: 'soneium',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M17.506 22.599a6.87 6.87 0 0 1-6.456-1.826c-2.262-2.263-2.704-5.62-1.07-8.28.676-1.098 1.317-1.754 1.87-2.306 2.284-2.274 6.478-6.414 6.478-6.414A12.36 12.36 0 0 0 7.161 7.16c-4.833 4.833-4.833 12.67 0 17.502a12.3 12.3 0 0 0 5.182 3.1z"/><path fill="currentColor" d="M14.317 9.223a6.87 6.87 0 0 1 6.456 1.827c2.263 2.262 2.704 5.62 1.07 8.279-.675 1.098-1.316 1.754-1.87 2.306a2751 2751 0 0 1-6.478 6.415 12.36 12.36 0 0 0 11.168-3.388c4.833-4.833 4.833-12.669 0-17.502a12.3 12.3 0 0 0-5.182-3.1z"/></svg>`,
};
